import { render } from "./Etiquetas.vue?vue&type=template&id=2adc9514&scoped=true"
import script from "./Etiquetas.vue?vue&type=script&lang=js"
export * from "./Etiquetas.vue?vue&type=script&lang=js"

import "./Etiquetas.vue?vue&type=style&index=0&id=2adc9514&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2adc9514"]])

export default __exports__